import React from 'react'
import TrashIcon from '../../elements/icons/TrashIcon'
import EmptyState from '../../elements/EmptyState'
import PlusIcon from '../../elements/icons/PlusIcon'
import ModalDialog from '../../layouts/ModalDialog'
import NewPrerequisiteSubject from './NewPrerequisiteSubject'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import { useDispatch } from 'react-redux'

const PrerequisiteSubjects = ({subjects, reload}) => {
    const [creatingPrerequisite, setCreatingPrerequisite] = React.useState(false)
    const dispatch = useDispatch()

    const handleDeletePrerequisite = async (id) => {
        if(window.confirm('Are you sure you want to delete this subject as a prerequisite? This action cannot be undone.')) {
            try {
    
                const headers = authHeader()
                await axios.delete(`${baseUrl}/academic-settings/prerequisite-subject/${id}`, { headers })
                dispatch({
                    type: SET_SUCCESS,
                    payload: 'Prerequisite subject removed successfully'
                })
                reload()
            } catch (error) {
                console.log('error removing prerequisite subject: ', error)
                dispatch({
                    type: ERROR,
                    error
                })
            }
        }
    }
    return (
        <>
            {subjects?.length > 0 ? <div className="w-full">
                {subjects.map((subject, index) => (
                    <div 
                        key={index} 
                        className="w-full rounded-lg bg-white p-5 mb-4 border border-gray-200 relative"
                    >
                        <div className="absolute top-2 right-2 flex flex-row-reverse items-center gap-x-2">
                            <button onClick={()=>{handleDeletePrerequisite(subject._id)}} className='p-1.5 bg-gray-100 rounded bg-transparent hover:bg-red-100 transition duration-200 text-xs flex items-center justify-center gap-x-1 text-gray-500 hover:text-vcm-purple'>
                                <TrashIcon className={`w-4 h-4`} />
                                Remove Prerequisite
                            </button>
                        </div>

                        <h3 className="font-semibold text-sm text-gray-800">{subject.subject.name}</h3>
                        <p className="text-sm text-gray-800">{subject.subject.description}</p>
                        <p className="text-sm text-gray-500 mt-1">Classes: {subject.classes.map(cl => cl.name).join(', ')}</p>
                        <p className="text-sm text-gray-500 mt-1">Prerequisite for <span className="text-gray-800 font-semibold capitalize">{subject?.studentStudyType?.toLowerCase() || 'all'} students</span> of the above classes</p>
                    </div>
                ))}
            </div> 
            :
                <EmptyState 
                    emptyStateTitle={`No prerequisite subjects.`}
                    emptyStateText={`No prerequisite subjects have been set yet. Click the button below to add a new prerequisite subject.`}
                />
            }
            <button onClick={()=>{setCreatingPrerequisite(true)}} className='w-max mx-auto p-3 text-xs border border-dashed border-gray-500 bg-white transition duration-200 flex items-center justify-center gap-x-1 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold'>
                <PlusIcon className={`w-4 h-4 inline-block`} />
                Add New Prerequisite Subject
            </button>

            <ModalDialog
                shown={creatingPrerequisite} 
                closeFunction={()=>{setCreatingPrerequisite(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Create a New Prerequisite Subject`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <NewPrerequisiteSubject 
                    close={()=>setCreatingPrerequisite(false)} 
                    reload={reload}
                />
            </ModalDialog>
        </>
    )
}

export default PrerequisiteSubjects